export function clamp(v: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, v));
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function length(x: number, y: number): number {
  return Math.hypot(x, y);
}

export function wrapPi(a: number): number {
  let x = (a + Math.PI) % (Math.PI * 2);
  if (x < 0) x += Math.PI * 2;
  return x - Math.PI;
}

export function angleAbsDiff(a: number, b: number): number {
  return Math.abs(wrapPi(a - b));
}

/** 0 = exactamente opostos. */
export function oppositeError(a: number, b: number): number {
  return Math.abs(angleAbsDiff(a, b) - Math.PI);
}

export function normalize(x: number, y: number): { x: number; y: number } {
  const len = Math.hypot(x, y);
  if (len < 1e-6) return { x: 0, y: 0 };
  return { x: x / len, y: y / len };
}

export function dist2(ax: number, ay: number, bx: number, by: number): number {
  const dx = ax - bx;
  const dy = ay - by;
  return dx * dx + dy * dy;
}

export function cubicBezier(
  t: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
): number {
  const x = clamp(t, 0, 1);
  if (x === 0 || x === 1) return x;

  let u = x;
  for (let i = 0; i < 8; i++) {
    const current = sampleBezier(u, x1, x2) - x;
    const deriv = sampleBezierDeriv(u, x1, x2);
    if (Math.abs(deriv) < 1e-6) break;
    u = clamp(u - current / deriv, 0, 1);
  }
  return sampleBezier(u, y1, y2);
}

/** Ease-in-out: cubic-bezier(in, 0, out, 1). */
export function bezierEaseInOut(t: number, easeIn: number, easeOut: number): number {
  return cubicBezier(t, clamp(easeIn, 0, 1), 0, clamp(easeOut, 0, 1), 1);
}

function sampleBezier(u: number, a: number, b: number): number {
  const c = 1 - u;
  return 3 * c * c * u * a + 3 * c * u * u * b + u * u * u;
}

function sampleBezierDeriv(u: number, a: number, b: number): number {
  const c = 1 - u;
  return 3 * c * c * a + 6 * c * u * (b - a) + 3 * u * u * (1 - b);
}
